<template>
  <div class="team-background-circle" :style="customStyle"></div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TeamBackgroundCircle',
  props: {
    left: Number,
    top: Number,
    backgroundColor: String
  },
  computed: {
    customStyle() {
      return `left: ${this.left}%; top: ${this.top}%; background-color: ${this.backgroundColor}`;
    }
  }
});
</script>

<style scoped lang="scss">
.team-background-circle {
  position: absolute;
  width: 115px;
  height: 115px;
  border-radius: 60px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  background-color: #f4f5f7;
}
</style>
